module.exports = __webpack_public_path__ + "img/logo_horizontal_black.f72e7910.svg";